export const checkToIncludeRequestor = (name: string) => {
  const notIncludes = ['curriculum__a', 'course__a'];

  return !notIncludes.some((inc) => inc === name);
};
